<!-- 销售退回验收数据操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                        :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0 && scope.row.isShowForm != 1">
                                    <el-form label-width="140px" id="mainInfo" class="baseForm" :model="sendDataInfo"
                                        ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField"
                                                v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <!-- 验收日期 -->
                                                <df-date v-if="formOneValue.fieldType == 'date'" :isShowLong="false"
                                                    :isdisabled="formOneValue.isChange == 0"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <!-- 收货单号 -->
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                    effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                                    placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]"
                                                        :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                        @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                        <el-button
                                                            @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                            slot="append" icon="el-icon-search"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <!-- 第二验收人 -->
                                                <el-input title="second" :disabled="formOneValue.isChange == 0"
                                                    v-else-if="formOneValue.entityField == 'rgcamSeccheckerName'"
                                                    @click.native="showSecchecker"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                                <el-input :disabled="formOneValue.isChange == 0"
                                                    @keyup.enter.native="nextFocus(formOneKey)" v-else
                                                    v-model="sendDataInfo[formOneValue.entityField]"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField"
                                                v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField"
                                                v-for="(formOneValue, formOneKey) in scope.row.jurconfigform"
                                                :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'rgcamSecchecker'">{{
                                                    sendDataInfo.rgcamSeccheckerName }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细 -->
                                    <el-form :inline="true" size="mini">
                                        <el-table :data="sendDataInfo.desuRgchaDetails" class="baseTable"
                                            ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle"
                                            @row-click="clickEvent" @selection-change="handleSelectionChange"
                                            :height="mxHeight" border style="width: 100%" size="mini">
                                            <el-table-column :prop="formOneValue.entityField"
                                                :label="formOneValue.showField" show-overflow-tooltip
                                                :min-width="formOneValue.fieldWeight"
                                                v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey"
                                                v-if="formOneValue.isShow == 1">
                                                <template slot="header" slot-scope="scope">
                                                    <div class="item-top" style="display: flex;align-items: center;">
                                                        <p class="gray-txt">{{ formOneValue.showField }}</p>
                                                        <el-popover v-if="formOneValue.entityField == 'rgcadSchnumber'"
                                                            placement="top-start" title="抽检规则" width="200"
                                                            trigger="hover" :content="popTitle">
                                                            <i slot="reference" class="el-icon-question"
                                                                style="font-size: 16px" />
                                                        </el-popover>
                                                    </div>
                                                </template>
                                                <template slot-scope="scope">
                                                    <span v-if="formOneValue.entityField == 'bgmId'">
                                                        {{ sendDataInfo.desuRgchaDetails[scope.$index].bgmName }}
                                                    </span>
                                                    <!-- 验收合格数量	 -->
                                                    <input class="oldInput" @input="test"
                                                        @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                        :ref="formOneValue.entityField"
                                                        @focus="setIndexFocus(scope.$index, formOneValue.focusField)"
                                                        v-else-if="formOneValue.entityField == 'rgcadQuanumber' && dataActionBox.actionType != 2"
                                                        type="number"
                                                        v-model="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]"
                                                        min="0"
                                                        :max="sendDataInfo.desuRgchaDetails[scope.$index].rgrdRecenum" />
                                                    <!-- 不合格数量	 -->
                                                    <input class="oldInput" @input="test"
                                                        @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                        :ref="formOneValue.entityField"
                                                        @focus="setIndexFocus(scope.$index, formOneValue.focusField)"
                                                        @blur="queryCount(scope.$index, formOneValue.entityField)"
                                                        v-else-if="formOneValue.entityField == 'rgcadRefnumber' && dataActionBox.actionType != 2"
                                                        type="number"
                                                        v-model="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]"
                                                        min="0"
                                                        :max="sendDataInfo.desuRgchaDetails[scope.$index].rgrdRecenum" />
                                                    <!-- 抽检数量	 -->
                                                    <input class="oldInput" @input="test"
                                                        @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                        :ref="formOneValue.entityField"
                                                        @focus="setIndexFocus(scope.$index, formOneValue.focusField)"
                                                        v-else-if="formOneValue.entityField == 'rgcadSchnumber' && dataActionBox.actionType != 2"
                                                        type="number"
                                                        v-model="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]"
                                                        min="0"
                                                        :max="sendDataInfo.desuRgchaDetails[scope.$index].rgrdRecenum" />
                                                    <!-- 备注 -->
                                                    <el-input
                                                        v-else-if="formOneValue.entityField == 'rgcadRemark' && dataActionBox.actionType != 2"
                                                        @keyup.enter="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                        :ref="formOneValue.entityField"
                                                        @focus="setIndexFocus(scope.$index, formOneValue.focusField)"
                                                        v-model.trim="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]"></el-input>
                                                    <!-- 有效期 -->
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a
                                                            @click="toDetail(sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span
                                                            v-if="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField])
                                                            }}
                                                        </span>
                                                    </span>
                                                    <!-- 生产日期 -->
                                                    <!-- 是否双验收 -->
                                                    <el-tag size="mini"
                                                        v-else-if="formOneValue.entityField == 'isReview'">
                                                        {{ $common.getIsGsp(formOneValue.formatterContent,
                                                            sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField])
                                                        }}
                                                    </el-tag>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select clearable size="mini"
                                                        v-else-if="formOneValue.fieldType == 'formatter'"
                                                        @focus="setIndexFocus(scope.$index, formOneValue.focusField)"
                                                        @visible-change="selectChange"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                                        :ref="formOneValue.entityField"
                                                        @change="changes(scope.$index, formOneValue.entityField, sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField])"
                                                        v-model="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]"
                                                        placeholder="请选择">
                                                        <el-option
                                                            v-for="item in JSON.parse(formOneValue.formatterContent)"
                                                            :key="item.key" :label="item.value" :value="item.key">
                                                        </el-option>
                                                    </el-select>
                                                    <el-input :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                                        clearable
                                                        @focus="setIndexFocus(scope.$index, formOneValue.focusField)"
                                                        @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, formOneValue.nosetField)"
                                                        v-model="sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]">
                                                        <el-button
                                                            @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, formOneValue.nosetField)"
                                                            slot="append" icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <span v-else>
                                                        {{
                                                            sendDataInfo.desuRgchaDetails[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                </template>
                                            </el-table-column>

                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>

                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo"
                    @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                    @showPrintPlan="showPrintPlan"></v-foot>

            </div>

        </div>
        <el-dialog title="输入验收人并且输入验收人的密码" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
            :modal-append-to-body='true' :append-to-body="true">
            <el-form label-position="top">
                <el-form-item label="账号">
                    <el-input v-model="reviewUserInfo.selectIndex"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input v-model="reviewUserInfo.passWord" show-password autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="userVerification()">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth"
            :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData"
                @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import ExtractionScheme from '../byComponents/ExtractionScheme.vue'
export default {
    name: 'salesReturnCheckAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionScheme },
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                "rgaiId": "",
                "rgamId": "",
                "rgcamSecchecker": "",
                "rgrmId": "",
                "rgcamRapdate": "",
                "rgcamRemark": "",
                "rgcamReserves1": "",
                "rgcamReserves2": "",
                "rgcamReserves3": "",
                "rgcamReserves4": "",
                "rgcamReserves5": "",
                "rgcamReserves6": "",
                "rgcamSapdept": "",
                "totalCount": 0,
                "totalMoney": 0,
                "totalNumber": 0,
                "rgrdId": "",
                "wobkemId": "",
                rgcamRedate: '',
                rgrmId: "",
                desuRgchaDetails: [],
            },
            rgapplysupinfo: {
                coId: '',
                coName: '',
                payMethod: '',
                settleMethod: '',
                credit: '',
                dismode: ''
            },//辅助对象
            showTabs: '',
            formDataList: [],
            userTwoList: [],  // 验收人

            reviewUserInfo: {
                opmId: '',
                passWord: '',
                selectIndex: 0,
            },
            dialogFormVisible: false,
            actionIndex: '',
            ishowRew: true,
            storageRoomList: [],
            exTitle: '',//缓存提取
            exWidth: '',
            DialogExtract: false,
            ppId: 'rgrmId',	//	销售退回收货明细ID
            exId: '',
            mxHeight: 0,
            parentSearchData: {},
            seIndex: 0,
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: '', // 赋值字段
            fField: '', //焦点字段
            nosField: '', // 不可赋值字段
            selectedDetailsIndex: 0,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: "0",
            DialogVisible: false,
            mxIndex: 0,
            mxFocus: '',
            seTitle: '',
            num: '',
            popTitle: ''

        }
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.desuRgchaDetails': {
            handler: function (newValue, oldValue) {
                if (this.dataActionBox.actionType == 2) return;
                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.totalNumber = 0
                this.sendDataInfo.totalCount = 0
                newValue.forEach((item, keys) => {
                    //收货数量 = 合格数量+不合格数量
                    // if(!item.rgrdRecenum || !item.rgcadQuanumber || item.rgcadRefnumber){
                    // 	return false
                    // }
                    if (item.rgcadQuanumber == '') {
                        item.rgcadQuanumber = 0
                    }
                    if (item.rgcadRefnumber == '') {
                        item.rgcadRefnumber = 0
                    }
                    if (item.rgcadSchnumber == '') {
                        item.rgcadSchnumber = 0
                    }
                    let sumNumber = NP.plus(item.rgcadQuanumber, item.rgcadRefnumber)
                    if (item.rgcadSchnumber > item.rgrdRecenum) {
                        this.$message({
                            message: '抽检数量数量不得大于收货数量，请重新设置',
                            type: 'error'
                        });
                        this.sendDataInfo.desuRgchaDetails[keys].rgcadSchnumber = 0
                    }
                    if (sumNumber > item.rgrdRecenum) {
                        this.$message({
                            message: '验收不合格数+验收合格数量不得大于收货数量，请重新设置',
                            type: 'error'
                        });
                        this.sendDataInfo.desuRgchaDetails[keys].rgcadQuanumber = 0
                        this.sendDataInfo.desuRgchaDetails[keys].rgcadRefnumber = 0
                    }
                    let thisMoney = this.$common.getDecimalInfo(3, NP.times(item.psprice, sumNumber))
                    this.sendDataInfo.desuRgchaDetails[keys].psmoney = thisMoney
                    this.sendDataInfo.desuRgchaDetails[keys].saleQumoney = this.$common.getDecimalInfo(3, NP.times(item.saleQuprice || 0, sumNumber))
                    let thisMoneyTwo = this.$common.getDecimalInfo(3, NP.times(item.price, sumNumber))
                    this.sendDataInfo.desuRgchaDetails[keys].money = thisMoneyTwo
                    // this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3,NP.plus(this.sendDataInfo.totalMoney,thisMoney))
                    this.sendDataInfo.totalMoney += Number(item.psmoney)
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, sumNumber))
                })
                this.sendDataInfo.totalCount = newValue.length
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        tabHeight(val) {
            this.mxHeight = val
        },
        changes(index, name, row) {
            console.log(index, name, row);
            this.sendDataInfo.desuRgchaDetails[index][name] = row
            this.sendDataInfo.desuRgchaDetails[index]['stName'] = "合格"
            setTimeout(() => {
                this.sendDataInfo.desuRgchaDetails[index]['refstName'] = ""
                this.sendDataInfo.desuRgchaDetails[index]['stName'] = ""
            }, 16.4)
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        setIndexFocus(index, fField) {
            this.mxIndex = index
            this.mxFocus = fField
        },
        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                this.tableNextFocus(this.mxFocus, this.mxIndex)
            }
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField) {
            removeEventListener('keyup', this.keyUp)
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            this.nosField = nosField
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener('keyup', this.keyUp)//创建监听键盘事件
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            console.log(this.sField, val, this.seIndex)
            let arr = this.sField.split(',')
            arr.forEach(item => {
                // this.sendDataInfo.desuRgchaDetails[this.seIndex][item] = val[item]
                this.$set(this.sendDataInfo.desuRgchaDetails[this.seIndex], item, val[item])
            })
            this.$nextTick(() => {
                this.tableNextFocus(this.fField, this.seIndex)
            })
        },
        // 获取冷链表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.desuRgchaDetails.length > 0) { }
                this.tableNextFocus('rgcadQuanumber', 0)
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].title == 'second') {
                aindex += 1
            }
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            console.log(field, index)
            if (field == 'keydown') {
                if (this.sendDataInfo.desuRgchaDetails[index + 1] != undefined) {
                    this.$refs['rgcadQuanumber'][index + 1].focus()
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgapplyDetails[this.selectedDetailsIndex]);
                    })
                }
                return
            }
            this.$refs[field][index].focus()
        },

        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.desuRgchaDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.desuRgchaDetails.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgchaDetails[this.selectedDetailsIndex], false);
                        return;
                    }
                    this.tableNextFocus('rgcadQuanumber', this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgchaDetails[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.desuRgchaDetails.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.desuRgchaDetails.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgchaDetails[this.selectedDetailsIndex], false);
                        return;
                    }
                    this.tableNextFocus('rgcadQuanumber', this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgchaDetails[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            this.tableNextFocus('rgcadQuanumber', this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        test() {
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
            this.sendDataInfo.totalCount = 0
            this.sendDataInfo.desuRgchaDetails.forEach((item, keys) => {
                let sumNumber = NP.plus(item.rgcadQuanumber, item.rgcadRefnumber)
                if (item.rgcadSchnumber > item.rgrdRecenum) {
                    this.$message({
                        message: '抽检数量数量不得大于收货数量，请重新设置',
                        type: 'error'
                    });
                    this.sendDataInfo.desuRgchaDetails[keys].rgcadSchnumber = 0
                }
                if (sumNumber > item.rgrdRecenum) {
                    this.$message({
                        message: '验收不合格数+验收合格数量不得大于收货数量，请重新设置',
                        type: 'error'
                    });
                    this.sendDataInfo.desuRgchaDetails[keys].rgcadQuanumber = 0
                    this.sendDataInfo.desuRgchaDetails[keys].rgcadRefnumber = 0
                }

                let thisMoney = this.$common.getDecimalInfo(3, NP.times(item.psprice, sumNumber))
                this.sendDataInfo.desuRgchaDetails[keys].psmoney = thisMoney
                let thisMoneyTwo = this.$common.getDecimalInfo(3, NP.times(item.price, sumNumber))
                this.sendDataInfo.desuRgchaDetails[keys].money = thisMoneyTwo
                // this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3,NP.plus(this.sendDataInfo.totalMoney,thisMoney))
                this.sendDataInfo.totalMoney += Number(item.psmoney)
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, sumNumber))
            })
            this.sendDataInfo.totalCount = this.sendDataInfo.desuRgchaDetails.length
            this.sendDataInfo.desuRgchaDetails.splice(1, 0)
        },
        // 触发提取方案
        openExComponents(e, index) {
            console.log(e);
            this.exId = e;
            this.seIndex = index
            this.init()
            this.DialogExtract = true;
            removeEventListener('keyup', this.keyUp)
        },

        // 获取 提取单数据
        async getExData(res) {
            let val = JSON.parse(JSON.stringify(res))
            if (val != "" || val != undefined) {
                this.sendDataInfo.desuRgchaDetails = []
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        for (const key1 in val.arrlistbychen) {
                            this.$set(this.sendDataInfo.desuRgchaDetails, key1, val.arrlistbychen[key1])
                            for (const key2 in val.arrlistbychen[key1]) {
                                this.$set(this.sendDataInfo.desuRgchaDetails[key1], key2, val.arrlistbychen[key1][key2])
                            }
                        }
                        this.sendDataInfo.desuRgchaDetails && this.sendDataInfo.desuRgchaDetails.forEach((item, i) => {
                            item['rgcadQuanumber'] = item.rgrdRecenum	//合格
                            item['rgcadRefnumber'] = 0	//不合格
                            this.samplingRulesQueryCount(item.rgrdRecenum, item.packingSpec, i, item.bgmId)
                            // item['rgcadSchnumber'] = this.num	//抽检
                            // console.log('抽检数量',item['rgcadSchnumber'])
                            item.rgcadCheckcon = '合格'
                        })
                    } else {
                        this.sendDataInfo[key] = val[key];
                    }
                }
                //验收日期
                this.sendDataInfo.rgcamRedate = new Date().getTime()
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgchaDetails[this.selectedDetailsIndex]);
                })
                // console.log(this.sendDataInfo);
            } else {
                this.$message({
                    message: '未拿到数据',
                    type: 'error'
                })
            }
            this.DialogExtract = false
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },
        async queryCount(index, type) {
            let cjnum = await this.samplingRulesQueryCount(Number(this.sendDataInfo.desuRgchaDetails[index].rgcadQuanumber) + Number(this.sendDataInfo.desuRgchaDetails[index].rgcadRefnumber), this.sendDataInfo.desuRgchaDetails[index].packingSpec, index, this.sendDataInfo.desuRgchaDetails[index].bgmId) //件数，装箱规格
            this.sendDataInfo.desuRgchaDetails[index].rgcadSchnumber = cjnum ? cjnum : "";
        },
        // 获取抽检数量
        async samplingRulesQueryCount(num, spec, i, bgmId) {
            let obj = {
                numbers: num, //	件数
                packingSpec: spec, //	装箱规格
                bgmId: bgmId,
                yslx: 1,
            }
            let responseData = await this.$http.samplingRulesQueryCount(obj);
            if (responseData.status == 200) {
                this.sendDataInfo.desuRgchaDetails[i].rgcadSchnumber = responseData.result
                this.sendDataInfo.desuRgchaDetails.splice(1, 0)
                console.log(this.sendDataInfo.desuRgchaDetails[i].rgcadSchnumber)
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
                return false;
            }
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },

        //确认新增
        async sendDataAction(formName) {
            let flag = false
            this.$refs[formName].validate((valid) => {
                if (valid) {

                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;
            if (!this.sendDataInfo.rgrmId) {
                this.$message({
                    message: '请先选择退回收货单',
                    type: 'error'
                });
                return false
            }


            for (let i = 0; i < this.sendDataInfo.desuRgchaDetails.length; i++) {
                const item = this.sendDataInfo.desuRgchaDetails[i]
                if (item.rgrdRecenum) {//数量
                    item.rgrdRecenum = parseFloat(item.rgrdRecenum)
                    item.rgcadQuanumber = parseFloat(item.rgcadQuanumber)
                    item.rgcadRefnumber = parseFloat(item.rgcadRefnumber)
                    item.rgcadSchnumber = parseFloat(item.rgcadSchnumber)
                    let doubleNum = item.rgcadQuanumber + item.rgcadRefnumber
                    if (item.rgrdRecenum != doubleNum) {//收货数量 = 合格数量+不合格数量
                        this.$message({
                            message: '请填写 ' + item.bgmName + ' 的合理数量',
                            type: 'error'
                        });
                        return false
                    }
                } else {
                    this.$message({
                        message: '请先检查明细数量',
                        type: 'error'
                    });
                    return false
                }

                if (item.rgcadQuanumber && !item.stId) {//库房
                    this.$message({
                        message: '请选择合格所存放的库房',
                        type: 'error'
                    });
                    return false
                }
                if (item.rgcadRefnumber && !item.refstId) {//库房
                    this.$message({
                        message: '请选择不合格所存放的库房',
                        type: 'error'
                    });
                    return false
                }
                if (item.rgrdRecenum < item.rgcadSchnumber) {//抽检不能大于收货
                    this.$message({
                        message: '抽检数量不能大于收货数量',
                        type: 'error'
                    });
                    return false
                }
            }

            var flagNum = false
            var flag1 = false
            var flagPsmoney = false
            var flagMoney = false
            var flagPrice = false
            var indexNum = 0
            var indexNum1 = 0
            var indexNum2 = 0
            var indexNum3 = 0
            var indexNum4 = 0
            this.sendDataInfo.desuRgchaDetails.forEach((item, index) => {
                let doubleNum1 = 0
                if (item.rgrdRecenum) {//数量
                    item.rgrdRecenum = parseFloat(item.rgrdRecenum)
                    item.rgcadQuanumber = parseFloat(item.rgcadQuanumber)
                    item.rgcadRefnumber = parseFloat(item.rgcadRefnumber)
                    item.rgcadSchnumber = parseFloat(item.rgcadSchnumber)
                    doubleNum1 = item.rgcadQuanumber + item.rgcadRefnumber
                }
                if ((doubleNum1 == "" || doubleNum1 == null || doubleNum1 <= 0) && !flagNum) {
                    indexNum3 = index
                    flagNum = true
                }
                if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {
                    if (this.$common.getDecimalInfo(3, NP.times(item.psprice, Number(doubleNum1))) != item.psmoney && !flagPsmoney) {
                        indexNum = index
                        flagPsmoney = true
                    }
                    var midmoney = NP.times(item.price, doubleNum1)
                    if (this.$common.getDecimalInfo(3, midmoney) != item.money && !flagMoney) {
                        indexNum1 = index
                        flagMoney = true
                    }
                    if (this.$common.getDecimalInfo(2, NP.divide(midmoney, doubleNum1)) != item.price && !flagPrice) {
                        indexNum2 = index
                        flagPrice = true
                    }
                }
            })
            if (flagNum) {
                return this.$message.error(`第${indexNum3 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum3].bgmName}数量不能为空或为零！`)
            }
            if (flagPsmoney) {
                return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum].bgmName}含税金额计算规则不符！`)
            }
            if (flagMoney) {
                return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum1].bgmName}金额计算规则不符！`)
            }
            if (flagPrice) {
                return this.$message.error(`第${indexNum2 + 1}行的${this.sendDataInfo.desuRgapplyDetails[indexNum2].bgmName}价格计算规则不符！`)
            }

            //验收人
            if (this.sendDataInfo.desuRgchaDetails.every((v) => v.isReview == 1) && this.sendDataInfo.rgcamSeccheckerName == '') return this.$message({
                message: '请选择第二验收人',
                type: 'error'
            });
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addSalesReturnCheck(sendData)
            } else {
                var responseData = await this.$http.setSalesReturnCheck(sendData)
            }

            if (responseData.status == 200) {
                this.$emit('drawerCancel')
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //显示第二验收人弹窗
        showSecchecker() {
            this.dialogFormVisible = true
        },
        // 验收人验证
        async userVerification() {
            var sendInfo = {
                opmAccount: this.reviewUserInfo.selectIndex,
                passWord: this.reviewUserInfo.passWord,
            }
            let res = await this.$http.reviewVerification(sendInfo)
            if (res.status == 200) {
                this.dialogFormVisible = false
                this.reviewUserInfo.selectIndex = res.result.opmName
                this.sendDataInfo['rgcamSecchecker'] = res.result.opmId
                this.sendDataInfo['rgcamSeccheckerName'] = res.result.opmName
                this.$message({
                    message: '验证通过',
                    type: 'success'
                });
            }
        },

        // 获取验收人
        async getSpecialUserTwo() {

            let responseData = await this.$http.getSpecialUser({ opmAcceptor: 1 })
            if (responseData.status == 200) {
                this.userTwoList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom()
            if (responseData.status == 200) {
                this.storageRoomList = responseData.result
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        //初始
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = ''
            }
            this.sendDataInfo.desuRgchaDetails = []
            this.sendDataInfo.rgcamRedate = this.$moment().valueOf();
            this.sendDataInfo.totalCount = 0
            this.sendDataInfo.totalMoney = 0
            this.sendDataInfo.totalNumber = 0
        },

        //取消
        initActionBox(formName) {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$common.delOrderInfo(this.sendDataInfo.rgrmId)
                this.$emit('drawerCancel')
                this.init()
                this.$refs[formName].resetFields();
            }).catch(() => { });
        },

        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.init()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                this.sendDataInfo = oldData
                this.rgapplysupinfo = oldData.rgapplysupinfo
                this.$nextTick(() => {
                    if (this.sendDataInfo.desuRgchaDetails.length == 0) return
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgchaDetails[this.selectedDetailsIndex]);
                })
                // console.log('oldData',oldData)
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                    this.rgapplysupinfo = dataInfo.rgapplysupinfo
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rgcamId)
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },

        reviewAction(index) {
            var data = this.sendDataInfo.desuRgchaDetails[index]
            // console.log(data.isReview)
            if (data.isReview == 0) {	//、、、、、
                this.actionIndex = index
                this.dialogFormVisible = true
                this.reviewUserInfo.opmId = ''
                this.reviewUserInfo.passWord = ''
                this.reviewUserInfo.selectIndex = 0
            } else {
                this.insertReviewData(index)
            }
        },

        // 新增复核数据
        insertReviewData(index) {
            this.ishowRew = false
            var data = this.sendDataInfo.desuRgchaDetails[index]
            this.dialogFormVisible = false
            this.ishowRew = true
        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            var arr = [{ entityField: "desuRgchaDetails" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "rgcamRedate", this.$moment().valueOf())
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
        },
        async querySamRule() {
            const res = await this.$http.samplingRulesQuerySamRule({ yslx: 1 })
            if (res.status == 200) {
                this.popTitle = res.result
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
        this.getSpecialUserTwo()
        this.getAllStorageRoom()
        this.querySamRule()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
        // addEventListener('keydown', this.keyDown)
        addEventListener('keyup', this.keyUp)//创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-drawer {
    outline: none;
}

.oldInput {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}
</style>
<style>
.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>